import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';
import {useAiChat} from '@/ai-chat/providers/ai-chat.context';
import styles from './ai-chat-assets-empty-state.module.scss';
import type {AiChatAssetsEmptyStateProps} from './ai-chat-assets-empty-state.types';
import {EMPTY_STATE_IMAGE_ILLUSTRATION_PATH} from './ai-chat-assets-empty-state.types';
import {AiChatAssetsVideoIllustration} from './components/ai-chat-assets-video-illustration/ai-chat-assets-video-illustration';

export function AiChatAssetsEmptyState({filter}: AiChatAssetsEmptyStateProps): ReactElement {
  const {state} = useAiChat();
  const isVideosFilter = filter === AiChatGeneratedAssetFilter.VIDEOS;

  const getCaption = (): string => {
    if (isVideosFilter) {
      return window.i18next.t('pmwjs_ai_videos_turn_designs_into_dynamic_videos');
    }

    return window.i18next.t('pmwjs_ai_images_transform_ideas_into_visuals');
  };

  const getCaptionClasses = (): string => {
    if (state.isSmall) {
      return `${styles.caption} ct-neutral-secondary`;
    }

    return `${styles.caption} ct-neutral-primary`;
  };

  const getCaptionSize = (): TextSize => {
    if (state.isSmall) {
      return TextSize.SM;
    }

    return TextSize.MD;
  };

  const getContainerClasses = (): string => {
    if (state.isSmall) {
      return `${styles.container} ${styles.containerSmall}`;
    }

    return styles.container;
  };

  const renderIllustration = (): ReactElement => {
    if (isVideosFilter) {
      return <AiChatAssetsVideoIllustration />;
    }

    return <img className={styles.imageIllustration} src={getAssetUrl(EMPTY_STATE_IMAGE_ILLUSTRATION_PATH)} alt="" loading="lazy" />;
  };

  return (
    <div className={getContainerClasses()}>
      {renderIllustration()}
      <Text className={getCaptionClasses()} size={getCaptionSize()} val={getCaption()} />
    </div>
  );
}
